/**
 * List of supported events in nodes. It was exposed in react-dom v15, but it got removed with
 * react-dom v16. Our BaseComponent's transferProps behavior is relying on them to whitelist
 * allowed props.
 * @todo remove behaviors that depend on these constants, as the react team suggests.
 */

export default {
    abort: 0,
    animationEnd: 0,
    animationIteration: 0,
    animationStart: 0,
    beforeInput: 0,
    blur: 0,
    canPlay: 0,
    canPlayThrough: 0,
    change: 0,
    click: 0,
    compositionEnd: 0,
    compositionStart: 0,
    compositionUpdate: 0,
    contextMenu: 0,
    copy: 0,
    cut: 0,
    doubleClick: 0,
    drag: 0,
    dragEnd: 0,
    dragEnter: 0,
    dragExit: 0,
    dragLeave: 0,
    dragOver: 0,
    dragStart: 0,
    drop: 0,
    durationChange: 0,
    emptied: 0,
    encrypted: 0,
    ended: 0,
    error: 0,
    focus: 0,
    input: 0,
    invalid: 0,
    keyDown: 0,
    keyPress: 0,
    keyUp: 0,
    load: 0,
    loadStart: 0,
    loadedData: 0,
    loadedMetadata: 0,
    mouseDown: 0,
    mouseEnter: 0,
    mouseLeave: 0,
    mouseMove: 0,
    mouseOut: 0,
    mouseOver: 0,
    mouseUp: 0,
    moveShouldSetResponder: 0,
    paste: 0,
    pause: 0,
    play: 0,
    playing: 0,
    progress: 0,
    rateChange: 0,
    reset: 0,
    responderEnd: 0,
    responderGrant: 0,
    responderMove: 0,
    responderReject: 0,
    responderRelease: 0,
    responderStart: 0,
    responderTerminate: 0,
    responderTerminationRequest: 0,
    scroll: 0,
    scrollShouldSetResponder: 0,
    seeked: 0,
    seeking: 0,
    select: 0,
    selectionChangeShouldSetResponder: 0,
    stalled: 0,
    startShouldSetResponder: 0,
    submit: 0,
    suspend: 0,
    timeUpdate: 0,
    touchCancel: 0,
    touchEnd: 0,
    touchMove: 0,
    touchStart: 0,
    touchTap: 0,
    transitionEnd: 0,
    volumeChange: 0,
    waiting: 0,
    wheel: 0,
};
